import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee';
import warehouse from '../class/warehouse';
import "../styles/ProductDetailPage.css";

const AllDischargeHistoryPage = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        let user_obj = new employee();
        user_obj.isLogged().then(() => {
            fetchData();
        }).catch(() => {
            navigate('/login');
        });
    }, []);

    const fetchData = async () => {
        try {
            const warehouseData = new warehouse();
            const callData = await warehouseData.getAllDischargeHistory();
            const historyArray = callData?.history || (Array.isArray(callData) ? callData : []);
            setHistory(historyArray);
        } catch (error) {
            console.error("Error fetching discharge history", error);
        } finally {
            setLoading(false);
        }
    };

    const formatDateTime = (timestamp) => {
        return new Date(Number(timestamp) * 1000).toLocaleString('it-IT', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const formatNumber = (value) => {
        if (value == null || isNaN(value)) return "0,00000";
        return Number(value).toLocaleString('it-IT', {
            minimumFractionDigits: 5,
            maximumFractionDigits: 5,
        });
    };

    if (loading) {
        return <div className="detail-page"><h2 className="page-title">Caricamento...</h2></div>;
    }

    return (
        <div className="detail-page">
            <div className="detail-header">
                <button onClick={() => navigate('/products')} className="btn-indietro">← Indietro</button>
                <h2 className="page-title">Storico Completo Scarichi</h2>
            </div>

            <div className="detail-section">
                {history.length === 0 ? (
                    <p className="no-data">Nessuno scarico trovato</p>
                ) : (
                    <table>
                        <thead>
                            <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                                <th>ID</th>
                                <th>N. Ordine Produzione</th>
                                <th>Cod. Articolo</th>
                                <th>Descrizione</th>
                                <th>Quantità</th>
                                <th>Data</th>
                                <th>N. DDT</th>
                                <th>Dipendente</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map(d => (
                                <tr key={d.id}>
                                    <td>{d.id}</td>
                                    <td>{d.order_production_number}</td>
                                    <td>{d.cod_article_las}</td>
                                    <td>{d.article_descr}</td>
                                    <td>{formatNumber(d.quantity)}</td>
                                    <td>{formatDateTime(d.discharge_date)}</td>
                                    <td>{d.ddt_number}</td>
                                    <td>{d.employee_name} {d.employee_surname}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default AllDischargeHistoryPage;
